import { render, staticRenderFns } from "./scrutinizerDialog.vue?vue&type=template&id=4d27a752&scoped=true&"
import script from "./scrutinizerDialog.vue?vue&type=script&lang=tsx&"
export * from "./scrutinizerDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./scrutinizerDialog.vue?vue&type=style&index=0&id=4d27a752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27a752",
  null
  
)

export default component.exports